import { Navigate } from 'react-router';

export default function SettingsDefaultRedirect() {
  return <Navigate to="/settings/partner-information" replace />;
}
